// ── ParticipantSPmtForm ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { fmt, fmtDate } from "../../../shared/format";
import { Badge, Btn, FInput, FInputNum, FSelect, Field, Icon, Modal, ReadOnlyForm, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const ParticipantSPmtForm = ({ initial, loanid, readOnly }) => {
    const { api, role, view, modal, setModal, closeModal, setConfirm, saving, error, saveRec, delRec } = useApp();
    const blank = {
      loanid, scheduleddate:"",
      scheduledprincipal:"", scheduledinterest:"", feetype:"", scheduledfee:"",
      othertype:"", scheduledother:"",
      origscheduledprincipal:"", origscheduledinterest:"",
      origscheduledfee:"", origscheduledother:""
    };
    const [f, set] = useFreshForm(initial||blank, "ParticipantScheduledPmts");
    const [psmtTab, setPsmtTab] = useState("current");
    const [childPmts, setChildPmts] = useState([]);
    const [childLoading, setChildLoading] = useState(false);

    const loadChildPmts = () => {
      if (!initial?.id) return;
      setChildLoading(true);
      api.get("getParticipantPmts?participantscheduledpmtid="+initial.id)
        .then(d=>{ setChildPmts(d); setChildLoading(false); })
        .catch(()=>setChildLoading(false));
    };

    useEffect(()=>{ loadChildPmts(); }, [initial?.id]);

    const feeTypeOptions = ["","Administrative Fee","Amendment Fees","Annual Fee","Collateral Monitoring Fee",
      "Default Interest","Late Fee","Legal Fees","Other","Unused Fee","Up Front Fee"];

    const totalSched = ((parseFloat(f.scheduledprincipal)||0)+(parseFloat(f.scheduledinterest)||0)+
      (parseFloat(f.scheduledfee)||0)+(parseFloat(f.scheduledother)||0)).toFixed(2);
    const totalOrig = ((parseFloat(f.origscheduledprincipal)||0)+(parseFloat(f.origscheduledinterest)||0)+
      (parseFloat(f.origscheduledfee)||0)+(parseFloat(f.origscheduledother)||0)).toFixed(2);

    const ST = ({ title }) => <div style={{ fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginTop:18, marginBottom:8, paddingBottom:4, borderBottom:"1.5px solid "+B.cyanLight, gridColumn:"1/-1" }}>{title}</div>;

    return <Modal title={readOnly?"View Participant Sched Payment":initial?"Edit Participant Sched Payment":"Add Participant Sched Payment"} onClose={closeModal} wide
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:"pspmt-edit",rec:initial,loanid,onDone:modal.onDone}); }:null}>

      <div style={{ display:"flex", gap:4, marginBottom:16, borderBottom:"1px solid var(--color-border-tertiary)" }}>
        <button onClick={()=>setPsmtTab("current")} style={{ background:"none", border:"none", borderBottom:psmtTab==="current"?"2px solid "+B.cyan:"2px solid transparent", color:psmtTab==="current"?B.cyan:"var(--color-text-secondary)", fontWeight:psmtTab==="current"?600:400, fontSize:13, padding:"6px 16px", cursor:"pointer", marginBottom:"-1px" }}>Current</button>
        {role.label==="Admin"&&<button onClick={()=>setPsmtTab("original")} style={{ background:"none", border:"none", borderBottom:psmtTab==="original"?"2px solid "+B.cyan:"2px solid transparent", color:psmtTab==="original"?B.cyan:"var(--color-text-secondary)", fontWeight:psmtTab==="original"?600:400, fontSize:13, padding:"6px 16px", cursor:"pointer", marginBottom:"-1px" }}>Original</button>}
      </div>

      <ReadOnlyForm readOnly={readOnly}>
        {psmtTab==="current"&&<div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 12px" }}>
          <ST title="General" />
          <Field label="Scheduled Date"><FInput value={f.scheduleddate?.slice(0,10)||""} onChange={set("scheduleddate")} type="date" /></Field>
          {initial && <Field label="Status"><div style={{ padding:"4px 0" }}><Badge s={f.status||"—"} /></div></Field>}
          {initial ? <><div /><div /></> : <><div /><div /><div /></>}
          <ST title="Current Scheduled Amounts" />
          <Field label="Principal"><FInputNum value={f.scheduledprincipal} onChange={set("scheduledprincipal")} /></Field>
          <Field label="Interest"><FInputNum value={f.scheduledinterest} onChange={set("scheduledinterest")} /></Field>
          <div /><div />
          <Field label="Fee Type"><FSelect value={f.feetype||""} onChange={set("feetype")} options={feeTypeOptions} /></Field>
          <Field label="Fee"><FInputNum value={f.scheduledfee} onChange={set("scheduledfee")} /></Field>
          <div /><div />
          <Field label="Other Type"><FSelect value={f.othertype||""} onChange={set("othertype")} options={feeTypeOptions} /></Field>
          <Field label="Other"><FInputNum value={f.scheduledother} onChange={set("scheduledother")} /></Field>
          <div />
          <Field label="Total Scheduled">
            <div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", fontWeight:500 }}>{fmt(totalSched)}</div>
          </Field>
        </div>}

        {psmtTab==="original"&&role.label==="Admin"&&<div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 12px" }}>
          <ST title="Original Scheduled Amounts" />
          <Field label="Principal"><FInputNum value={f.origscheduledprincipal} onChange={set("origscheduledprincipal")} /></Field>
          <Field label="Interest"><FInputNum value={f.origscheduledinterest} onChange={set("origscheduledinterest")} /></Field>
          <div /><div />
          <Field label="Fee"><FInputNum value={f.origscheduledfee} onChange={set("origscheduledfee")} /></Field>
          <Field label="Other"><FInputNum value={f.origscheduledother} onChange={set("origscheduledother")} /></Field>
          <div />
          <Field label="Total Original Scheduled">
            <div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", fontWeight:500 }}>{fmt(totalOrig)}</div>
          </Field>
        </div>}
      </ReadOnlyForm>

      {/* ── Child Participant Payments ── */}
      {initial?.id&&<>
        <div style={{ fontSize:11, fontWeight:700, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginTop:24, marginBottom:8, paddingBottom:4, borderBottom:"1.5px solid "+B.cyanLight, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span>Participant Payments
            <span style={{ marginLeft:8, fontSize:11, fontWeight:400, color:"var(--color-text-secondary)" }}>
              {childPmts.length} record{childPmts.length!==1?"s":""}
            </span>
          </span>
          {role.canEdit&&<Btn onClick={()=>setModal({
            type:"participantpmt-add",
            loanid: initial.loanid||loanid,
            participantscheduledpmtid: initial.id,
            onDone: loadChildPmts
          })} variant="primary">+ Add Payment</Btn>}
        </div>

        {childLoading
          ? <Spinner />
          : childPmts.length===0
            ? <div style={{ fontSize:12, color:"var(--color-text-secondary)", padding:"8px 0" }}>No payments recorded.</div>
            : <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
                  <thead><tr>
                    <Th>Payment Date</Th>
                    <Th>Principal</Th>
                    <Th>Interest</Th>
                    <Th>Fee Type</Th>
                    <Th>Fee</Th>
                    <Th>Other Type</Th>
                    <Th>Other</Th>
                    <Th>Total</Th>
                    <Th></Th>
                  </tr></thead>
                  <tbody>
                    {childPmts.map(p=>(
                      <tr key={p.id}
                        style={{ cursor:"pointer" }}
                        onClick={()=>setModal({
                          type:"participantpmt-view",
                          rec:{...p,id:p.id,loanid:p.loanid},
                          returnTo:{ type:"pspmt-view", rec:initial },
                          onDone: loadChildPmts
                        })}
                        onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"}
                        onMouseLeave={e=>e.currentTarget.style.background=""}>
                        <Td>{fmtDate(p.paymentdate)}</Td>
                        <TdNum>{fmt(p.principalamount||0)}</TdNum>
                        <TdNum>{fmt(p.interestamount||0)}</TdNum>
                        <Td>{p.feetype||"—"}</Td>
                        <TdNum>{fmt(p.feeamount||0)}</TdNum>
                        <Td>{p.othertype||"—"}</Td>
                        <TdNum>{fmt(p.otheramount||0)}</TdNum>
                        <TdNum style={{ fontWeight:500 }}>{fmt(p.totalpayment||0)}</TdNum>
                        <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
                          <Btn onClick={()=>setModal({
                            type:"participantpmt-view",
                            rec:{...p,id:p.id,loanid:p.loanid},
                            returnTo:{ type:"pspmt-view", rec:initial },
                          })}><Icon type="view" /></Btn>
                          {role.canEdit&&<Btn onClick={()=>setModal({
                            type:"participantpmt-edit",
                            rec:{...p,id:p.id,loanid:p.loanid},
                            loanid: p.loanid||loanid,
                            participantscheduledpmtid: initial.id,
                            returnTo:{ type:"pspmt-view", rec:initial },
                            onDone: loadChildPmts
                          })}><Icon type="edit" /></Btn>}
                          {role.canDelete&&<Btn variant="danger" onClick={e=>{ e.stopPropagation(); setConfirm({
                            msg:"Delete this participant payment?",
                            onConfirm:()=>delRec("ParticipantPmts",p.id,"Deleted participant payment",loadChildPmts)
                          }); }}><Icon type="delete" /></Btn>}
                        </div></Td>
                      </tr>
                    ))}

                    {/* ── Subtotal row ── */}
                    <tr style={{ background:B.cyanLight, borderTop:"1.5px solid "+B.cyan }}>
                      <td style={{ padding:"7px 12px", fontSize:12, fontWeight:600, color:B.cyanDark, textAlign:"right" }}>
                        Total ({childPmts.length})
                      </td>
                      <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(childPmts.reduce((s,p)=>s+(parseFloat(p.principalamount)||0),0))}</TdNum>
                      <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(childPmts.reduce((s,p)=>s+(parseFloat(p.interestamount)||0),0))}</TdNum>
                      <td />
                      <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(childPmts.reduce((s,p)=>s+(parseFloat(p.feeamount)||0),0))}</TdNum>
                      <td />
                      <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(childPmts.reduce((s,p)=>s+(parseFloat(p.otheramount)||0),0))}</TdNum>
                      <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(childPmts.reduce((s,p)=>s+(parseFloat(p.totalpayment)||0),0))}</TdNum>
                      <td />
                    </tr>
                  </tbody>
                </table>
              </div>
        }
      </>}

      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveParticipantScheduledPmt",{...f,loanid:f.loanid||loanid,totalscheduledpayment:totalSched,totalorigscheduledpayment:totalOrig},initial?"Edited":"Added","ParticipantScheduledPmts",(initial?"Updated":"Added")+" participant payment",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
